import { useRef } from 'react';
import styles from './styles.module.scss';
import clsx from 'clsx';

const ModalComponent = ({ children, title, closeModal, overflow }) => {
  const modal = useRef();

  function outsideClick() {
    closeModal();
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay} onClick={() => outsideClick()} />
      <div
        className={clsx(styles.container, {
          [styles.overflowFix]: overflow,
        })}
        ref={modal}
      >
        <h2 className="pb-2">{title}</h2>
        <div>{children}</div>
        <div className={styles.closeButton} onClick={closeModal}>
          <i className="fas fa-times fs-5" />
        </div>
      </div>
    </div>
  );
};
export default ModalComponent;
